import React from 'react'
import "./fifth.css"
function Second() {
  return (
    <div className="d1">
<div className='text'>
  <span className='title'>
  run is now
  <br/>
immersive

  </span><br/>
<span>
listen to the world's best athletes, runners and storytellers. Get a inside view of their mental models- how they train, think and win. Or run across world's leading running circuits or scenic environments such as Beach Run, Jungle Safari or Mountain Trail along with ambient soundscapes
</span>
<button className='btn' href="#">Know More</button>
</div>
<div className='img-fifth'>
<img src="second.png" />
</div>
     </div>
);
    }
    
   
export default Second;